<template>
  <CModal :onEsc="handleClose" persistent show show-icon size="small">
    <CCard
      aria-modal="true"
      :bordered="false"
      class="w-[600px] p-4"
      role="dialog"
      size="medium"
      :theme-overrides="{
        fontSizeMedium: '16px',
        titleFontSizeMedium: '20px',
        lineHeight: '32px',
        paddingMedium: '0',
        borderRadius: '8px',
        boxShadow: '4px 2px 24px rgba(73, 68, 68, 0.1)',
      }"
    >
      <div class="flex flex-col gap-3">
        <div class="font-700 font-size-[18px]">
          {{ t('canvasUI.components.savedCanvases.CSavedCanvasesManagement.accountModal.title') }}
        </div>

        <div class="mb-2">
          <CSelect
            bordered
            clearable
            filterable
            :loading="accountsLoading"
            :options="accounts"
            :placeholder="
              t('canvasUI.components.savedCanvases.CSavedCanvasesManagement.accountModal.searchPlaceholder')
            "
            remote
            :show-checkmark="false"
            :value="selectedAccount?.value"
            @blur="updateSearch('')"
            @search="updateSearch($event)"
            @update:show="updateSearch('')"
            @update:value="setAccount"
          />
        </div>

        <div class="mt-3 flex justify-between">
          <CButton type="secondary" @click="handleClose">
            {{ t('canvasUI.components.savedCanvases.CSavedCanvasesManagement.deleteDialog.cancel') }}
          </CButton>
          <CButton :disabled="!selectedAccount" type="primary" @click="handleSelect">
            {{ t('canvasUI.components.savedCanvases.CSavedCanvasesManagement.accountModal.select') }}
          </CButton>
        </div>
      </div>
    </CCard>
  </CModal>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import CModal from '@lib/components/CModal/CModal.vue'
import CCard from '@lib/components/CCard/CCard.vue'
import CSelect from '@lib/components/CSelect/CSelect.vue'
import CButton from '@lib/components/CButton/CButton.vue'

const props = defineProps<{
  accounts: { label: string; value: string }[]
  accountsLoading: boolean
}>()

const emit = defineEmits<{
  close: []
  select: [account: { value: string; label: string }]
  search: [value: string]
}>()

const { t } = useI18n()
const selectedAccount = ref<{ value: string; label: string } | null>(null)

function handleClose() {
  selectedAccount.value = null
  emit('close')
}

function handleSelect() {
  if (selectedAccount.value) {
    emit('select', selectedAccount.value)
  }
}

function setAccount(value: string | null) {
  if (!value) {
    selectedAccount.value = null
    return
  }

  const account = props.accounts.find((a) => a.value === value)
  if (account) {
    selectedAccount.value = account
  }
}

function updateSearch(value: string) {
  emit('search', value)
}
</script>
